<script lang="ts">
  import Icon from './Icon.svelte';

  export let img: string = null;
  export let size = '40px';
  export let className = '';
</script>

{#if img}
  <img
    alt="avatar"
    src={img}
    style="width: {size}; height: {size};"
    class="avatar {className}"
  />
{:else}
  <div
    class="avatar placeholder"
    style="width: {size}; height: {size}; font-size: calc({size}/2)"
  >
    <Icon name="eva-person-outline" />
  </div>
{/if}

<style lang="scss">
  .avatar {
    border-radius: 50%;
  }

  .placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--light-3);
  }
</style>
